import { render, staticRenderFns } from "./logoff.vue?vue&type=template&id=80adab52&scoped=true&"
import script from "./logoff.vue?vue&type=script&lang=js&"
export * from "./logoff.vue?vue&type=script&lang=js&"
import style0 from "./logoff.vue?vue&type=style&index=0&id=80adab52&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80adab52",
  null
  
)

export default component.exports